<template>
  <div class="d-flex pa-2 full-width overflow-hidden" v-on="$listeners">
    <v-avatar class="mt-3" color="#F4F7FA" size="80">
      <v-icon size="50">mdi-palette</v-icon>
    </v-avatar>
    <div class="pl-sm-4 overflow-hidden">
      <div class="font-weight-bold" :title="item.name">
        <span>{{ item.name }}</span>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong>{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <slot />
      <div v-if="current_user_role == 3">
        <base-button
          small
          color="#00ED64"
          v-if="current_user_role == 3"
          @click="onOpenKeyDialog"
        >
          <span>{{ $t('workspace.api_keys') }}</span>
        </base-button>
        <KeyDialog ref="dialog" :workspace="workspace" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import KeyDialog from '../keys/key-dialog.vue'
export default {
  components: {
    KeyDialog,
  },
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: (vm) => ({
    current_user_role: 0,
    workspace: {
      loading: false,
      items: [],
    },
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    item() {
      return this.value
    },
  },
  created() {
    this.getRole()
    this.workspace.items = [this.item]
  },
  methods: {
    getRole() {
      for (var i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].name == 'Quản Trị Hệ Thống') {
          this.current_user_role = 1
          break
        }
        if (this.currentUser.roles[i].name == 'Biên tập') {
          this.current_user_role = 2
          break
        }
        if (
          this.currentUser.roles[i].name ==
          'Phát triển các ứng dụng, phần mềm khác'
        ) {
          this.current_user_role = 3
        }
      }
    },
    onOpenKeyDialog() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
  },
}
</script>

<style scoped></style>
